module.exports = __webpack_public_path__ + "7467b9bafa36b222c9ce2ea1b2864d9a.png";